import * as React from "react";
import PropTypes from 'prop-types';

const SvgMobile = props => {
  if (props.id !== "_svgmobile") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M28.17 4l-17.065.03C9.883 4.03 9 4.958 9 6.16v27.68c0 1.203.883 2.13 2.105 2.13L28.17 36a2.138 2.138 0 002.164-2.16V6.16c0-1.203-.94-2.16-2.164-2.16zm-8.503 29.307c-.62 0-1.123-.476-1.123-1.063 0-.59.503-1.065 1.123-1.065s1.122.476 1.122 1.065c0 .587-.502 1.063-1.122 1.063zm6.737-4.658c0 .723-.737 1.464-1.544 1.464H14.333a1.393 1.393 0 01-1.393-1.389l-.01-19.637c-.038-.319.054-.687.28-.931.262-.28.703-.4 1.123-.4H25c.667 0 1.404.55 1.404 1.33V28.65z" fill="#202020" /></svg>;
};

SvgMobile.displayName = "_svgmobile";
SvgMobile.propTypes = {
  id: PropTypes.string
};
SvgMobile.defaultProps = {
  id: ''
};
export default SvgMobile;